import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { resetCaptcha } from '../../../Libs/Captcha/captchaConfig'
import { storageSet } from '../../../Libs/Collector/StorageAction';
import { broadcastAuth } from '../../../Libs/Auth/crossTabSession';
import api from "../../../Libs/Api/AxiosConfig";



export const getLogin = createAsyncThunk(
    'Login/getLogin',
    async (data) => {

        const apiData = {
            email: data.email,
            password: data.password,
            pin: data.pin,
            reCaptcha: data.reCaptcha,
      
        }


     
        const res = await api.post(`/User/Login`, apiData);
        return res.data;
    })


export const LoginSlice = createSlice({
    name: 'Login',
    initialState: {
        loading: false,
        error: false,
        status: 1,
        auth: false,
        modules: [],
        reason: "",
        requestCount: 0


    },
    reducers: {
        SetLoading: (state) => {
            state.loading = true;

        },
        ClearErrorReducer: (state) => {
            state.auth = false;
            state.error = false;
            state.reason = "";

        },
        LogoutReducer: (state) => {

            state.loading = false;
            state.auth = false;
            localStorage.removeItem("token");
            localStorage.removeItem("refreshToken");
            state.reason = "";
            // Aynı tarayıcıdaki diğer sekmeleri de çıkışa zorla.
            broadcastAuth('logout');

        },
        RefershLoginReducer: (state, action) => {
            state.loading = false;
            state.auth = true;
            state.reason = "";
            storageSet("token", action.payload.data.token);
            storageSet("refreshToken", action.payload.data.refreshToken);
        },

        // Açılışta (yeni sekme / yenileme) localStorage token'ı varsa oturumu geri yükle.
        // Token sunucuda her istekte (Authenticate) doğrulanır; geçersizse istekler başarısız olur.
        BootAuthReducer: (state) => {
            state.auth = true;
            state.loading = false;
        },

    },
    extraReducers: (builder) => {

        builder.addCase(getLogin.pending, (state, { payload }) => {
            state.loading = true;
            
        })

        builder.addCase(getLogin.fulfilled, (state, { payload }) => {
            state.loading = false;
            resetCaptcha();
            if (payload.payload.status) {

                const { token, refreshToken } = payload.payload;
                state.auth = true;
                storageSet("token", token);
                storageSet("refreshToken", refreshToken);
                state.reason = "";
                state.requestCount = 0
                // Diğer sekmeler yeni (muhtemelen farklı) hesabı yansıtsın diye yenilensin.
                broadcastAuth('login');

            } else {
                state.requestCount = 1
                state.auth = false;
                state.error = true;
                state.reason = payload.payload.reason;
            }
        })

        builder.addCase(getLogin.rejected, (state, { payload }) => {
            state.loading = false;
            state.error = true;
            state.reason = "";
        })

    }
})

export const { LogoutReducer, RefershLoginReducer, ClearErrorReducer, SetLoading, BootAuthReducer } = LoginSlice.actions;



export const LoginReducer = LoginSlice.reducer